export const ALPHABETICAL = {
  label: 'Alphabetical',
  value: 'alphabetical',
};

export const FEATURED = {
  label: 'Featured',
  value: 'featured',
};

export const POPULAR = {
  label: 'Most Popular',
  value: 'popular',
};

export const RELEVANCE = {
  label: 'Relevance',
  value: 'relevance',
};

export const ALL_SORT_BY_TYPES = [ALPHABETICAL, RELEVANCE, POPULAR];

export const SORT_BY_TYPES_PRE_SEARCH = [ALPHABETICAL, POPULAR];
export const SORT_BY_TYPES_POST_SEARCH = [ALPHABETICAL, RELEVANCE, POPULAR];

export const SORT_ORDER = {
  ascending: 'asc',
  descending: 'desc',
};

export const getLabelFromValue = value => {
  const sortOrder = ALL_SORT_BY_TYPES.find(e => e.value === value);
  return sortOrder ? sortOrder.label : 'Sort by';
};

export default ALL_SORT_BY_TYPES;
